"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCssVariables = createCssVariables;
var _tombacCommons = require("./tombacCommons");
function colorGrades(colorDefs, color) {
  return Object.keys(colorDefs[color]).filter(key => !isNaN(parseFloat(key)));
}
function alphaGrades(colorDefs, color, type) {
  return Object.keys(colorDefs[color][type === "inverted" ? "invertedAlpha" : "alpha"]);
}
function gradeVariable(colorDefs, color, grade, alpha) {
  const name = `${color}-${alpha === "inverted" ? "i" : ""}${alpha ? "a" : ""}${grade}`;
  const value = alpha === "alpha" ? colorDefs[color].alpha[grade] : alpha === "inverted" ? colorDefs[color].invertedAlpha[grade] : colorDefs[color][grade];
  return {
    [name]: value
  };
}
function colorVariables(theme) {
  const variables = {};
  Object.keys(theme.colors).map(color => {
    const colorDefs = theme.colors;
    variables[color] = colorDefs[color][500];
    colorGrades(colorDefs, color).forEach(grade => Object.assign(variables, gradeVariable(colorDefs, color, grade)));
    alphaGrades(colorDefs, color).forEach(grade => Object.assign(variables, gradeVariable(colorDefs, color, grade, "alpha")));
    if (colorDefs[color].invertedAlpha) alphaGrades(colorDefs, color, "inverted").forEach(grade => Object.assign(variables, gradeVariable(colorDefs, color, grade, "inverted")));
    return variables;
  });
  return variables;
}
function spacingVariables(theme) {
  const variables = {};
  [0.5, 1, 2, 3, 4, 5].forEach(space => variables[`space-${space === 0.5 ? "half" : space}`] = (0, _tombacCommons.pxToUnit)(theme.baseSpace * space, theme.baseUnit));
  return variables;
}
function fontFamilyVariables(theme) {
  return {
    "font-family": theme.typography.defaultFontFamily,
    "alt-font-family": theme.typography.altFontFamily
  };
}
function createCssVariables(theme) {
  let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "--";
  const variables = Object.assign({}, colorVariables(theme), spacingVariables(theme), fontFamilyVariables(theme));
  if (prefix) {
    Object.keys(variables).forEach(key => {
      variables[`${prefix}${key}`] = variables[key];
      delete variables[key];
    });
  }
  return variables;
}
//# sourceMappingURL=createCssVariables.js.map